import styled from 'styled-components';

export const BackgroundWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${props => props.$isCorporateMode ? '#F5E5E3' : '#F20'};
  position: relative;
  transition: background-color 0.5s ease-in-out;

  @media (max-width: 1728px) {
    min-height: 100vh;
  }
`;

export const LandingPage = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 2;
  pointer-events: ${props => props.$isCorporateMode ? 'auto' : 'none'};
  /* Prevent overflow from menu animation, but allow scrolling in corporate mode */
  overflow: ${props => props.$isCorporateMode ? 'auto' : 'hidden'};

  @media (max-width: 1728px) {
    min-height: 100vh;
  }
`;
